module.exports = __webpack_public_path__ + "img/card-FMCG2.85f3622b.svg";